import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a3b56e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appointment_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "appointment_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "appointment_title_text" }, "本当にキャンセルしてよろしいですか？")
], -1))
const _hoisted_3 = { class: "appointment_button" }
const _hoisted_4 = { class: "appointment_button" }

import { ref } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import { useRouter } from 'vue-router';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentcancelView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);

const cancelInterview = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('appointment/cancelInterview');
    store.dispatch('toasts/appendTimeToast', { label: '面談をキャンセルしました' });
    isLoading.value = false;
    transitionPage();
  } catch (e) {
    store.dispatch('toasts/appendTimeToast', { label: '面談のキャンセルに失敗しました', duration: null });
    isLoading.value = false;
  }
};

const transitionPage = () => {
  router.push({ name: 'd12' });
};

const transitionPreviousPage = () => {
  router.push({ name: 'd10' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseButton, {
          theme: "primary",
          disabled: isLoading.value,
          onClick: cancelInterview
        }, {
          default: _withCtx(() => [
            _createTextVNode("はい")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("いいえ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})